import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { RootState } from '@/store'
import { Module } from 'vuex'
import { actions } from '@/store/realworksStatusRules/actions'
import { mutations } from '@/store/realworksStatusRules/mutations'
import { getters } from '@/store/realworksStatusRules/getters'

export interface RealworksStatusRuleState {
    loading: boolean,
    error: string|null,
    realworksStatusRules: RealworksStatusRule[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    companyFilter: string|null,
}

const state: RealworksStatusRuleState = {
    loading: false,
    error: null,
    realworksStatusRules: [],
    totalItems: 0,
    totalPages: 0,
    page: 1,
    itemsPerPage: 10,
    orderField: null,
    orderDirection: null,
    companyFilter: null,
}

export const RealworksStatusRuleModule: Module<RealworksStatusRuleState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
